import { SET_FAVORITE_EXERCISES, SET_FAVORITE_WORKOUTS, SET_TO_PLAY_FAVORITE } from "./types";

const initialState = {
    exercises: [],
    workouts: [],
    toPlay: null
};

export default function (state = initialState, action) {

    switch (action.type) {
        case SET_FAVORITE_EXERCISES:
            return {
                ...state,
                exercises: action.list
            }

        case SET_FAVORITE_WORKOUTS:
            return {
                ...state,
                workouts: action.list
            }

        case SET_TO_PLAY_FAVORITE:
            return {
                ...state,
                toPlay: action.data
            }

        default:
            return state;
    }
}